// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","737":"fb7d5399","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"b3ee1aa6d4b41ed1eb43","737":"a32a3061dc1649824379","883":"6dcddbcfa34fdcc5f3b0"}[chunkId] + ".js";
};